import {MODAL_LAYER_Z_INDEX} from '../modal-layers';

export const errorLayerStyles = {
  backdrop: {
    position: 'fixed',
    inset: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    pointerEvents: 'all',
    zIndex: MODAL_LAYER_Z_INDEX.feedbackBackdrop,
    cursor: 'pointer',
  },
};
